import { ErrorKind } from '../ErrorToast';

export const getErrorCode = (error: Error | null): ErrorKind | null => {
  if (!error) return null;

  if (error?.message.includes('application is closed')) {
    return 'application-closed';
  }

  return 'unknown';
};
